import {
    Hidden,
    Drawer,
    ListItem,
    ListItemText,
    List,
    Divider,
    Typography
} from '@material-ui/core';
import useTranslation from 'next-translate/useTranslation';
import React, { useMemo, useState } from 'react';
import { useLinkDrawerLink, useTitleInViewState } from './LegalProvider';
import useDrawerStyles from './styles/drawer';
import { Scrollbars } from 'react-custom-scrollbars';
import 'react-perfect-scrollbar/dist/css/styles.css';
import clsx from 'clsx';

interface Props {}

const LegalDrawer = ({}: Props) => {
    const { t } = useTranslation('legal');
    const classes = useDrawerStyles();
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const onLinkedContentClicked = useLinkDrawerLink();
    const onViewIndex = useTitleInViewState();

    const titles = useMemo(() => {
        return t('tableOfContents', {}, { returnObjects: true }) as any;
    }, []);
    // <a href={`#${TEXT_ID_BASE}${index + 1}`} className={classes.url}>
    const drawer = (
        <div className={classes.root}>
            <Typography variant="h5" className={classes.drawerTitle}>{`${t('termsT1')} & ${t(
                'mutT3'
            )}`}</Typography>
            <Divider />
            <List>
                <ListItem button key={0}>
                    <div className={classes.headlineWrapper}>
                        <div
                            className={clsx(classes.indicator, {
                                [classes.hide]: onViewIndex === 0
                            })}
                        />
                        <ListItemText
                            primary={titles[0]}
                            onClick={() => onLinkedContentClicked(titles[0])}
                        />
                    </div>
                </ListItem>

                <List>
                    {titles.slice(1, 15).map((text: string, index: number) => (
                        <div key={index} className={classes.indicatorWrapper}>
                            <div
                                className={clsx(classes.indicator, {
                                    [classes.hide]: index + 1 === onViewIndex
                                })}
                            />
                            <ListItem button key={text}>
                                <ListItemText
                                    className={classes.drawerText}
                                    primary={text}
                                    onClick={() => onLinkedContentClicked(text)}
                                />
                            </ListItem>
                        </div>
                    ))}
                </List>
                <ListItem button key={15}>
                    <div className={classes.headlineWrapper}>
                        <div
                            className={clsx(classes.indicator, {
                                [classes.hide]: onViewIndex === 15
                            })}
                        />
                        <ListItemText
                            primary={titles[15]}
                            onClick={() => onLinkedContentClicked(titles[15])}
                        />
                    </div>
                </ListItem>
            </List>
        </div>
    );
    return (
        <nav className={classes.drawer}>
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Hidden mdUp implementation="js">
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    classes={{ root: classes.drawerPaper, paper: classes.drawerPaper }}
                    ModalProps={{
                        keepMounted: true // Better open performance on mobile.
                    }}>
                    {drawer}
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="js">
                <Drawer classes={{ paper: classes.drawerPaper }} variant="permanent" open>
                    <Scrollbars className={classes.drawerPaper}>{drawer}</Scrollbars>
                </Drawer>
            </Hidden>
        </nav>
    );
};

export default LegalDrawer;
